import React from 'react';

const OrganizationForm = ({
  show,
  formData,
  setFormData,
  editingOrg,
  timezones,
  currencies,
  organizationTypes,
  onSubmit,
  onCancel,
  onNameChange,
  styles,
}) => {
  if (!show) return null;

  return (
    <form onSubmit={onSubmit} style={styles.form}>
      <div style={styles.formGroup}>
        <label style={styles.label}>Organization Name *</label>
        <input
          type="text"
          style={styles.input}
          value={formData.name}
          onChange={onNameChange}
          placeholder="Your Baseball Academy"
          required
        />
      </div>

      <div style={styles.formGroup}>
        <label style={styles.label}>Slug *</label>
        <input
          type="text"
          style={styles.input}
          value={formData.slug}
          onChange={(e) => setFormData({ ...formData, slug: e.target.value })}
          placeholder="your-baseball-academy"
          required
        />
        <small style={{ fontSize: '12px', color: '#666' }}>
          URL-friendly identifier (lowercase, hyphens only)
        </small>
      </div>

      <div style={styles.formGroup}>
        <label style={styles.label}>Organization Type *</label>
        <select
          style={styles.select}
          value={formData.organization_type}
          onChange={(e) => setFormData({ ...formData, organization_type: e.target.value })}
          disabled={editingOrg !== null}
          required
        >
          {organizationTypes.map((type) => (
            <option key={type.value} value={type.value}>
              {type.label}
            </option>
          ))}
        </select>
        {editingOrg && (
          <small style={{ fontSize: '12px', color: '#666' }}>
            Organization type cannot be changed after creation
          </small>
        )}
      </div>

      <div style={styles.formGroup}>
        <label style={styles.label}>Timezone</label>
        <select
          style={styles.select}
          value={formData.timezone}
          onChange={(e) => setFormData({ ...formData, timezone: e.target.value })}
        >
          {timezones.map((tz) => (
            <option key={tz} value={tz}>
              {tz}
            </option>
          ))}
        </select>
      </div>

      <div style={styles.formGroup}>
        <label style={styles.label}>Currency</label>
        <select
          style={styles.select}
          value={formData.currency}
          onChange={(e) => setFormData({ ...formData, currency: e.target.value })}
        >
          {currencies.map((curr) => (
            <option key={curr} value={curr}>
              {curr}
            </option>
          ))}
        </select>
      </div>

      <div style={styles.formGroup}>
        <label style={styles.label}>Season</label>
        <input
          type="text"
          style={styles.input}
          value={formData.season}
          onChange={(e) => setFormData({ ...formData, season: e.target.value })}
          placeholder="Spring 2025"
        />
      </div>

      <div style={styles.formActions}>
        <button
          type="button"
          style={{ ...styles.button, ...styles.secondaryButton }}
          onClick={onCancel}
        >
          Cancel
        </button>
        <button type="submit" style={{ ...styles.button, ...styles.primaryButton }}>
          {editingOrg ? 'Update Organization' : 'Create Organization'}
        </button>
      </div>
    </form>
  );
};

export default OrganizationForm;
